/*  WidgetFrame.tsx
    — reusable “chrome” wrapper for every dashboard widget          */
import React, {forwardRef, useState} from 'react';
import {IconButton, Menu, MenuItem, Divider} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import {useDispatch} from 'react-redux';
import {rdwRemoveWidget} from 'appredux/actions';

/* Single source of widget IDs */
import {WdgId} from 'screens/Dashboard/Overview/widgets';

import './WidgetFrame.scss';

/* ---------- props ---------- */
interface IProps {
  id: WdgId;
  children: React.ReactNode;
  onResize(w: 4 | 5 | 9): void;
}

/* ---------- component ---------- */
const WidgetFrame = forwardRef<HTMLDivElement, IProps>(
  ({id, children, onResize}, ref) => {
    const [anchor, setAnchor] = useState<null | HTMLElement>(null);
    const dispatch = useDispatch();

    /* close the dropdown */
    const close = () => setAnchor(null);

    /* remove widget from the dashboard */
    const handleRemove = () => {
      dispatch(rdwRemoveWidget(id));
      close();
    };

    return (
      <div ref={ref} className="widget-frame">
        {/* draggable strip */}
        <div className="drag-handle" />

        {/* ︙ menu trigger */}
        <IconButton
          className="widget-menu"
          size="small"
          onClick={(e) => setAnchor(e.currentTarget)}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>

        {/* dropdown menu */}
        <Menu anchorEl={anchor} open={!!anchor} onClose={close}>
          {[4, 5, 9].map((w) => (
            <MenuItem
              key={w}
              onClick={() => {
                onResize(w as 4 | 5 | 9);
                close();
              }}
            >
              {w === 9 ? 'Full (9)' : `Half (${w})`}
            </MenuItem>
          ))}

          <Divider />

          <MenuItem onClick={handleRemove} style={{color: '#c62828'}}>
            Remove widget
          </MenuItem>
        </Menu>

        {/* widget body */}
        <div className="frame-body">{children}</div>
      </div>
    );
  },
);

WidgetFrame.displayName = 'WidgetFrame';
export default WidgetFrame;
